<div class="row text-center animated fadeIn">
    <div class="col">
        <i class="fas fa-sync-alt fa-5x fa-spin django"></i>
    </div>
</div>